import { render, staticRenderFns } from "./PackSelector.vue?vue&type=template&id=007c708c&scoped=true"
import script from "./PackSelector.vue?vue&type=script&lang=js"
export * from "./PackSelector.vue?vue&type=script&lang=js"
import style0 from "./PackSelector.vue?vue&type=style&index=0&id=007c708c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c708c",
  null
  
)

export default component.exports